import localeCore from "../../core/locale.core";
import { UserMembership } from "../../types/customer";

export default function CustomerActiveMemberships({
  membership,
  className = "",
}: {
  membership?: UserMembership[];
  className?: string;
}) {
  const labels =
    membership
      ?.filter((m) => m.isActive)
      .map((m) => localeCore.getLocaleValueDefaultFallback(m.name))
      .filter(Boolean) ?? [];

  if (labels.length === 0) return null;

  return <p className={className}>{labels.join(" · ")}</p>;
}
